/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import Toggler from 'shared/ui/components/form-components/Toggler.vue';

// Constants
import { SESSION_TYPES } from 'libs/services/live-stream';

const __vue_script__ = {

    name: 'LiveDisplayPlacementForm',

    components: {
        Toggler
    },

    props: {
        value: {
            type: Object,
            required: true
        },

        showSlideToggle: {
            type: Boolean,
            required: true
        }
    },

    data() {
        return {
            locationOptions: [{
                label: this.$i18n.t('live_sessions.settings.live_display.display_settings_on_site'),
                icon: 'ic-presentations',
                value: SESSION_TYPES.IN_PERSON
            }, {
                label: this.$i18n.t('live_sessions.settings.live_display.display_settings_virtual'),
                icon: 'icon-location-pin',
                value: SESSION_TYPES.VIRTUAL
            }],
            SESSION_TYPES
        };
    },

    computed: {
        showLiveStream: {
            get() { return true; }, // Virtual hubs should always show the live stream. Keep the setter to overwite old `false` values.
            set() { this.$emit('change', { field: 'show_live_stream', value: true }); }
        },
        showInteractivity: {
            get() { return this.value.show_interactivity; },
            set(value) { this.$emit('change', { field: 'show_interactivity', value }); }
        },
        showClaps: {
            get() { return this.value.show_claps; },
            set(value) { this.$emit('change', { field: 'show_claps', value }); }
        },
        showSlides: {
            get() { return this.value.show_slides; },
            set(value) { this.$emit('change', { field: 'show_slides', value }); }
        },
        location: {
            get() { return this.value.location; },
            set(value) { this.$emit('change', { field: 'location', value }); }
        }
    },

    methods: {
        setLocation(location) {
            this.location = location;
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "live-display-placement-form" }, [
    _c("h4", { staticClass: "headlines" }, [
      _vm._v(
        _vm._s(_vm.$t("live_sessions.settings.live_display.display_placement"))
      ),
    ]),
    _c(
      "div",
      { staticClass: "session-type-buttons" },
      _vm._l(_vm.locationOptions, function (bt) {
        return _c(
          "button",
          {
            key: bt.value,
            class: { active: _vm.location === bt.value },
            attrs: { name: "session_type" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return function () {
                  return _vm.setLocation(bt.value)
                }.apply(null, arguments)
              },
            },
          },
          [
            _c("i", { staticClass: "icon", class: bt.icon }),
            _c("div", { staticClass: "title" }, [_vm._v(_vm._s(bt.label))]),
          ]
        )
      }),
      0
    ),
    _vm.location === _vm.SESSION_TYPES.VIRTUAL
      ? _c("div", { staticClass: "virtual-location-hint" }, [
          _vm._v(
            _vm._s(
              _vm.$t(
                "live_sessions.settings.live_display.virtual_location_hint"
              )
            )
          ),
        ])
      : _vm._e(),
    _c(
      "div",
      { staticClass: "toggler-section" },
      [
        _vm.location === _vm.SESSION_TYPES.VIRTUAL
          ? _c(
              "validation-provider",
              { attrs: { slim: true } },
              [
                _c("toggler", {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$t(
                        "live_sessions.settings.live_display.show_live_stream_tooltip"
                      ),
                      expression:
                        "$t('live_sessions.settings.live_display.show_live_stream_tooltip')",
                    },
                  ],
                  attrs: {
                    name: "show-live-stream",
                    "on-label":
                      "live_sessions.settings.live_display.show_live_stream",
                    "off-label":
                      "live_sessions.settings.live_display.show_live_stream",
                    disabled: true,
                  },
                  model: {
                    value: _vm.showLiveStream,
                    callback: function ($$v) {
                      _vm.showLiveStream = $$v
                    },
                    expression: "showLiveStream",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _c(
          "validation-provider",
          { attrs: { slim: true } },
          [
            _c("toggler", {
              attrs: {
                name: "show-interactivity",
                "on-label":
                  "live_sessions.settings.live_display.show_interactivity",
                "off-label":
                  "live_sessions.settings.live_display.show_interactivity",
                "inline-hint": _vm.$t(
                  "live_sessions.settings.live_display.show_interactivity_hint"
                ),
              },
              model: {
                value: _vm.showInteractivity,
                callback: function ($$v) {
                  _vm.showInteractivity = $$v
                },
                expression: "showInteractivity",
              },
            }),
          ],
          1
        ),
        _vm.showSlideToggle
          ? _c(
              "validation-provider",
              { attrs: { slim: true } },
              [
                _c("toggler", {
                  attrs: {
                    name: "show-slides",
                    "on-label":
                      "live_sessions.settings.live_display.show_slides",
                    "off-label":
                      "live_sessions.settings.live_display.show_slides",
                  },
                  model: {
                    value: _vm.showSlides,
                    callback: function ($$v) {
                      _vm.showSlides = $$v
                    },
                    expression: "showSlides",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _c(
          "validation-provider",
          { attrs: { slim: true } },
          [
            _c("toggler", {
              attrs: {
                name: "show-claps",
                "on-label": "live_sessions.settings.live_display.show_claps",
                "off-label": "live_sessions.settings.live_display.show_claps",
              },
              model: {
                value: _vm.showClaps,
                callback: function ($$v) {
                  _vm.showClaps = $$v
                },
                expression: "showClaps",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/live-session/LiveDisplayPlacementForm.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__